export const LIST_ENTITY_NAMES = {
	COUPONS: 'coupons',
	PARTNER_COUPONS: 'partnerCoupons',
	AB_TESTS: 'abtests',
	BANNERS: 'banners',
	LOBBY_BANNERS: 'lobbyBanners',
	TOURNAMENT_CONFIGS: 'tournamentConfigs',
	TOURNAMENT_BUCKETS: 'tournamentBuckets',
	TOURNAMENT_BUCKET_CONFIGS: 'tournamentBucketConfigs',
	REFERRAL_POLICY: 'referralPolicy',
	USERS: 'users',
	ROLES: 'roles',
	BUCKETS: 'buckets',
	COUPON_CONVERSIONS: 'couponConversions',
	PARTNER_COUPON_CONVERSIONS: 'partnerCouponConversions',
	BULK_PARTNER_COUPONS: 'bulkPartnerCoupons',
	REFEREE_REWARD: 'refereeReward',
	REFERRER_REWARD: 'referrerReward',
	APK_VERSION: 'apkVersion',
	APK_WEB: 'apkWeb',
	APK_APP: 'apkApp',
	MIN_APP_VERSION: 'minAppVersion',
	EXAMPLE: 'example',
	WALLET: 'wallet',
	MTT_SCHEMA: 'mttSchema',
	STATIC_SEGMENTS: 'staticSegments',
	SOCIAL_MEMES: 'memes',
	SOCIAL_SPOTLIGHTS: 'spotlights',
	SCHEDULED_DOWNTIME: 'scheduledDowntime',
	NOTICES: 'notices',
	CTD_OFFERS: 'ctdOffers',
	CTD_CONFIGS: 'ctdConfigs',
	GST_OFFERS: 'gstOffers',
	GST_CONFIGS: 'gstConfigs',
	TDS_CONFIGS: 'tdsConfigs',
	USER_SEGMENT: 'userSegment',
	DOWNTIME_REFUNDS: 'downtimeRefund',
	QUESTION_BANK: 'questionBank',
	CASHBACK_UTIL: 'cashbackUtil',
	predictAndWinV2: 'predictAndWinV2',
	UTILITIES_ASSET_UPLOAD: 'assetUpload',
	REFERRAL: 'referral',
	zkRevertDashboard: 'zkRevertDashboard',
	HAPPY_HOURS: 'happyHours',
	zupeeKheloJeeto: 'zupeeKheloJeeto',
	magicBox: 'magicBox',
	TDS_OFFERS: 'tdsOffers',
	ruleEngine: 'ruleEngine',
	zkDashBoardUpdate: 'zkDashBoardUpdate',
	ATHENA_CRUDS: 'athenaCrudRequest',
	THEMES_VALIDATION: 'themesValidation',
	INTERNAL_USER: 'internalUser',
	tournamentV2: 'tournamentV2',
	adsDashboard: 'adsDashboard',
	chatDashboard: 'chatDashboard',
	CONFIG_IMPACT: 'configImpactKeys'
};

const entities = [
	'coupon',
	'partnerCoupon',
	'banner',
	'lobbyBanner',
	'homepageView',
	'tournament',
	'apkUpdateInfo',
	'zookeeper',
	'user',
	'role',
	'abTest',
	'example',
	'wallet',
	'homePageLayout',
	'mttSchema',
	'staticSegments',
	'memes',
	'spotlights',
	'scheduledDowntime',
	'questionBank',
	'notices',
	'assetUpload',
	'referral',
	'happyHour',
	'zupeeKheloJeeto',
	'ruleEngine',
	'bonusMoneyLambda',
	'athenaDashboard',
	'internalUser',
	'tournamentV2',
	'adsDashboard',
	'chatDashboard',
	'aiCompanionDashboard',
	'talkzyData',
	'gameplayGuardrailReview',
	'mandateRefund'
] as const;

// prettier-ignore
export type Entity = typeof entities[number];

type Resources = {
	[key: string]: string;
};

export type ChangesVersionHistory = {
	key: string;
	oldValue: any;
	newValue: any;
};

type Scopes = { [key: string]: { [key: string]: string } };

export const PAGE_NAMES: { [key: string]: string } = {
	settings: 'settings',
	gameAdmin: 'gameAdmin',
	dashboard: 'dashboard',
	settingsV2: 'settingsV2'
};

export const DASHBOARD_ACTIONS = {
	REDIRECT_TO_RULE_ENGINE: 'redirectToRuleEngine',
	LIST_SUPER_SIX: 'listSuperSix',
	LIST_BONUS_MONEY_LAMBDA_REQUEST: 'listBonusMoneyLambdaRequest',
	ATHENA_DASHBOARD: 'athenaDashboard',
	INTERNAL_USER: 'internalUser'
};

export const ASSET_RESOURCES: Resources = {
	website: 'website',
	app: 'app'
};

export const DASHBOARD_RESOURCES: Resources = {
	coupon: 'coupon',
	partnerCoupon: 'partnerCoupon',
	banner: 'banner',
	lobbyBanner: 'lobbyBanner',
	tournament: 'tournament',
	apkUpdateInfo: 'apkUpdateInfo',
	abTest: 'abTest',
	homepageView: 'homepageView',
	// example: 'example',
	wallet: 'wallet',
	homePageLayout: 'homePageLayout',
	mttSchema: 'mttSchema',
	staticSegments: 'staticSegments',
	social: 'social',
	scheduledDowntime: 'scheduledDowntime',
	notices: 'notices',
	userSegment: 'userSegment',
	referral: 'referral',
	questionBank: 'questionBank',
	cashbackUtil: 'cashbackUtil',
	predictAndWinV2: 'predictAndWinV2',
	utilities: 'utilities',
	// zkRevertDashboard: 'zkRevertDashboard',
	happyHour: 'happyHour',
	zupeeKheloJeeto: 'zupeeKheloJeeto',
	downtimeRefund: 'downtimeRefund',
	bonusMoneyLambda: 'bonusMoneyLambda',
	magicBox: 'magicBox',
	lottery: 'lottery',
	finance: 'finance',
	outbound: 'outbound',
	athenaDashboard: 'athenaDashboard',
	delink: 'delink',
	internalUser: 'internalUser',
	ruleEngine: 'ruleEngine',
	superSix: 'superSix',
	tournamentV2: 'tournamentV2',
	themesZipValidation: 'themesZipValidation',
	adsDashboard: 'adsDashboard',
	chatDashboard: 'chatDashboard',
	aiCompanionDashboard: 'aiCompanionDashboard',
	configImpact: 'configImpact',
	talkzyData: 'talkzyData',
	gameplayGuardrailReview: 'gameplayGuardrailReview',
	mandateRefund: 'mandateRefund',
	generic: 'generic'
};

export const GAME_ADMIN_RESOURCES: Resources = {
	zookeeper: 'zookeeper',
	zkRevertDashboard: 'zkRevertDashboard',
	zkPreProd: 'zkPreProd',
	zkDashBoardUpdate: 'zkDashBoardUpdate'
};

export const ACL_ENTITIES = [
	DASHBOARD_RESOURCES.ruleEngine,
	DASHBOARD_RESOURCES.superSix,
	GAME_ADMIN_RESOURCES.zkDashBoardUpdate,
	DASHBOARD_RESOURCES.lottery,
	DASHBOARD_RESOURCES.athenaDashboard,
	DASHBOARD_RESOURCES.bonusMoneyLambda,
	DASHBOARD_RESOURCES.internalUser,
	DASHBOARD_RESOURCES.tournamentV2,
	DASHBOARD_RESOURCES.adsDashboard,
	DASHBOARD_RESOURCES.chatDashboard,
	DASHBOARD_RESOURCES.aiCompanionDashboard,
	DASHBOARD_RESOURCES.configImpact,
	DASHBOARD_RESOURCES.talkzyData,
	DASHBOARD_RESOURCES.gameplayGuardrailReview,
	DASHBOARD_RESOURCES.mandateRefund
];

export const SETTINGS_RESOURCES: Resources = {
	user: 'user',
	role: 'role'
};

export const DASHBOARD_SCOPES: Scopes = {
	[DASHBOARD_RESOURCES.zookeeper]: {
		listServices: 'listServices',
		listKeys: 'listKeys',
		getValueForKey: 'getValueForKey',
		updateKey: 'updateKey',
		updateZKUpdateReq: 'updateZKUpdateReq',
		getAllPendingZkUpdateReqs: 'getAllPendingZkUpdateReqs'
	},
	[DASHBOARD_RESOURCES.coupon]: {
		getCoupons: 'getCoupons',
		updateCoupon: 'updateCoupon',
		addUsersToCoupon: 'addUsersToCoupon',
		createCoupon: 'createCoupon',
		deployCoupon: 'deployCoupon'
	},
	[DASHBOARD_RESOURCES.partnerCoupon]: {
		getCoupons: 'getCoupons',
		updateCoupon: 'updateCoupon',
		createCoupon: 'createCoupon',
		getPartnerCoupons: 'getPartnerCoupons',
		createPartnerCoupons: 'createPartnerCoupons',
		updatePartnerCoupons: 'updatePartnerCoupons',
		deployCoupon: 'deployCoupon'
	},
	[DASHBOARD_RESOURCES.banner]: {
		getAllBanners: 'getAllBanners',
		addBanners: 'addBanners',
		updateBannerStatus: 'updateBannerStatus',
		createUserSegment: 'createUserSegment',
		deployBanner: 'deployBanner',
		getVersionHistory: 'getVersionHistory',
		uploadImage: 'uploadImage'
	},
	[DASHBOARD_RESOURCES.lobbyBanner]: {
		getAllBanners: 'getAllBanners',
		addBanners: 'addBanners',
		updateBannerStatus: 'updateBannerStatus',
		deployBanner: 'deployBanner',
		deleteBanner: 'deleteBanner',
		uploadImage: 'uploadImage'
	},
	[DASHBOARD_RESOURCES.homepageView]: {
		showView: 'showView'
	},
	[DASHBOARD_RESOURCES.tournament]: {
		createTournament: 'createTournament',
		rollbackTournamentFile: 'rollbackTournamentFile',
		getTournamentCsvStatus: 'getTournamentCsvStatus',
		uploadTournamentCsv: 'uploadTournamentCsv',
		listTournamentObjects: 'listTournamentObjects',
		getTournamentDiff: 'getTournamentDiff',
		approveTournamentCsv: 'approveTournamentCsv'
	},
	[DASHBOARD_RESOURCES.staticSegments]: {
		listStaticSegments: 'listStaticSegments',
		createSegment: 'createSegment',
		editSegment: 'editSegment',
		downloadCsv: 'downloadCsv',
		downloadHistoricalCsv: 'downloadHistoricalCsv',
		showVersionHistory: 'showVersionHistory',
		deleteSegment: 'deleteSegment'
	},
	[DASHBOARD_RESOURCES.apkUpdateInfo]: {
		getApkVersions: 'getApkVersions',
		getApkVersion: 'getApkVersion',
		getAppUpdates: 'getAppUpdates',
		getWebsiteUpdates: 'getWebsiteUpdates',
		addApkVersionInfo: 'addApkVersion',
		createAppUpdateInfo: 'createAppUpdateInfo',
		addWebsiteUpdateInfo: 'addWebsiteUpdateInfo',
		updateApkVersionInfo: 'updateApkVersion',
		updateAppUpdateInfo: 'updateAppUpdateInfo',
		updateWebsiteUpdateInfo: 'updateWebsiteUpdateInfo',
		deployWebsiteUpdate: 'deployWebsiteUpdate',
		getSubAppUpdates: 'getSubAppUpdates',
		createSubAppUpdateInfo: 'createSubAppUpdateInfo',
		updateSubAppUpdateInfo: 'updateSubAppUpdateInfo',
		getSubAppUpdateLogs: 'getSubAppUpdateLogs',
		getSuperAppUpdateLogs: 'getSuperAppUpdateLogs',
		viewSubAppUpdateLogs: 'viewSubAppUpdateLogs',
		viewSuperAppUpdateLogs: 'viewSuperAppUpdateLogs',
		uploadApk: 'uploadApk',
		addApkVersion: 'addApkVersion',
		getWebsiteUpdatesV2: 'getWebsiteUpdatesV2',
		addWebsiteUpdateInfoV2: 'addWebsiteUpdateInfoV2',
		updateWebsiteUpdateInfoV2: 'updateWebsiteUpdateInfoV2',
		deployWebsiteUpdateV2: 'deployWebsiteUpdateV2',
		getDashBoardsName: 'getDashBoardsName',
		getTestBucketsName: 'getTestBucketsName'
	},
	[DASHBOARD_RESOURCES.homePageLayout]: {
		getVersionSupportedHomepageLayout: 'getVersionSupportedHomepageLayout',
		createLayout: 'createlayout',
		createLayoutOrder: 'createLayoutOrder',
		editLayoutOrder: 'editLayoutOrder',
		editLayouts: 'editLayouts',
		removeLayoutOrder: 'removeLayoutOrder',
		removeLayouts: 'removeLayouts',
		submitLayouts: 'submitLayouts',
		clearLayouts: 'clearLayouts',
		showLayoutOrder: 'showLayoutOrder'
	},
	[DASHBOARD_RESOURCES.abTest]: {
		getExperiments: 'getExperiments',
		updateExperiment: 'updateExperiment',
		getVersionHistory: 'getVersionHistory',
		getExperimentVersions: 'getExperimentVersions',
		revertExperimentToVersion: 'revertExperimentToVersion',
		fixUsersBucket: 'fixUsersBucket',
		createExperiment: 'createExperiment'
	},
	[DASHBOARD_RESOURCES.wallet]: {
		getCsvDetails: 'getCsvDetails',
		addCsvDetails: 'addCsvDetails',
		addCoinsFromCsv: 'addCoinsFromCsv',
		getAccountingType: 'getAccountingType',
		uploadCsv: 'uploadCsv'
	},
	[DASHBOARD_RESOURCES.mttSchema]: {
		getMttSchema: 'getMttSchema',
		createMttSchema: 'createMttSchema',
		updateMttSchema: 'updateMttSchema',
		deleteMttSchema: 'deleteMttSchema',
		uploadCsv: 'uploadCsv'
	},
	[DASHBOARD_RESOURCES.social]: {
		getAllMemePosts: 'getAllMemePosts',
		updateMemePost: 'updateMemePost',
		createNewMemePost: 'createNewMemePost',
		getMemeUploadPreSignedUrl: 'getMemeUploadPreSignedUrl',
		listContent: 'listContent',
		createContent: 'createContent',
		updateContent: 'updateContent',
		getPreSignedUrl: 'getPreSignedUrl'
	},
	[DASHBOARD_RESOURCES.scheduledDowntime]: {
		listScheduledDowntime: 'listScheduledDowntime',
		updateScheduledDowntime: 'updateScheduledDowntime',
		addScheduledDowntime: 'addScheduledDowntime'
	},
	[DASHBOARD_RESOURCES.userSegment]: {
		listSegment: 'getSegmentList',
		updateSegment: 'updateSegment',
		deleteSegment: 'deleteSegment',
		forceDeleteSegment: 'forceDeleteSegment',
		viewSegment: 'viewSegment',
		getUserDetails: 'getUsers',
		updateUserDetails: 'updateUserSegment',
		listUserSegments: 'getUserSegment',
		createSegment: 'createSegment',
		updateUserSegmentToVip: 'updateUserSegmentToVip',
		listUserRtfs: 'getUserRtfs',
		assignBulkSegments: 'assignBulkSegments',
		getBulkSegmentData: 'getBulkSegmentData',
		runSegment: 'execute',
		scheduleSegment: 'schedule',
		deleteScheduledCronJob: 'deleteScheduledCronJob',
		activateSegment: 'makeSegmentLive',
		nonRapidRunSegment: 'executeNonRapid',
		nonRapidScheduleSegment: 'scheduleNonRapid'
	},
	[DASHBOARD_RESOURCES.generic]: {
		getPlatformFeatures: 'userSegment/getPlatformFeatures?limit=#&skip=#&searchText=#',
		updatePlatformFeature: 'userSegment/updatePlatformFeature',
		getFeatureSegmentsList: 'userSegment/getFeatureSegmentsList?limit=#&skip=#&searchText=#',
		updateFeatureSegments: 'userSegment/updateFeatureSegments'
	},
	[DASHBOARD_RESOURCES.downtimeRefund]: {
		listRefundRequest: 'listRefundRequest',
		createRefundRequest: 'createRefundRequest',
		approveRefundRequest: 'approveAndProcessRefundRequest',
		rejectRefundRequest: 'rejectRefundRequest',
		downloadRefundRequest: 'downloadRefundRequest',
		getRefundRequestStatus: 'getRefundRequestStatus'
	},
	[DASHBOARD_RESOURCES.referral]: {
		updateUserReferralCode: 'updateUserReferralCode',
		updateUserReferralSegment: 'updateUserReferralSegment',
		getReferralSegmentPolicies: 'getReferralSegmentPolicies'
	},
	[DASHBOARD_RESOURCES.questionBank]: {
		saveQuestionBank: 'saveQuestionBank'
	},
	[DASHBOARD_RESOURCES.notices]: {
		getNotices: 'getNotices',
		updateNotice: 'updateNotice',
		createNotice: 'createNotice',
		selectWidgetType: 'selectWidgetType'
	},
	[DASHBOARD_RESOURCES.cashbackUtil]: {
		getCashbackUtils: 'getCashbackUtils',
		addedCashbackSegments: 'addedCashbackSegments',
		editCashbackSegments: 'editCashbackSegments',
		updatePriorityList: 'updatePriorityList',
		deleteCashbackSegments: 'deleteCashbackSegments'
	},
	[DASHBOARD_RESOURCES.predictAndWinV2]: {
		createContest: 'createContest',
		updateContest: 'updateContest'
	},
	[DASHBOARD_RESOURCES.utilities]: {
		getAllAssets: 'getAllAssets',
		createNewAsset: 'createNewAsset',
		getMiscAssetUploadPreSignedUrl: 'getMiscAssetUploadPreSignedUrl',
		viewAsset: 'viewAsset',
		addIndianAddress: 'addIndianAddress'
	},
	[DASHBOARD_RESOURCES.happyHour]: {
		getHappyHours: 'getHappyHours',
		updateHappyHour: 'updateHappyHour',
		createHappyHour: 'createHappyHour'
	},
	[DASHBOARD_RESOURCES.finance]: {
		getCTDOffers: 'getCTDActiveOffers',
		updateCTDOffers: 'updateCTDOffers',
		createCTDOffers: 'createCTDOffers',
		removeCTDOffers: 'removeCTDOffers',
		getCTDConfigs: 'getCTDConfigs',
		updateCTDConfigs: 'updateCTDConfigs',
		createCTDConfigs: 'createCTDConfigs',
		getGSTOffers: 'getGSTActiveOffers',
		updateGSTOffers: 'updateGSTOffers',
		createGSTOffers: 'createGSTOffers',
		removeGSTOffers: 'removeGSTOffers',
		getGSTConfigs: 'getGSTConfigs',
		updateGSTConfigs: 'updateGSTConfigs',
		createGSTConfigs: 'createGSTConfigs',
		removeGSTConfigs: 'removeGSTConfigs',
		getTDSOffers: 'getTDSActiveOffers',
		updateTDSOffers: 'updateTDSOffers',
		createTDSOffers: 'createTDSOffers',
		removeTDSOffers: 'removeTDSOffers',
		getTDSConfigs: 'getTDSConfigs',
		updateTDSConfigs: 'updateTDSConfigs',
		createTDSConfigs: 'createTDSConfigs',
		removeTDSConfigs: 'removeTDSConfigs',
		getCtdPayoutSegmentsAndPriorityList: 'getCtdPayoutSegmentsAndPriorityList',
		updatePriorityList: 'updateCTDConfigPriority',
		updatePaymentPGFailureData: 'updatePaymentPGFailureData'
	},
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: {
		uploadQuestions: 'uploadQuestions',
		uploadAnswers: 'uploadAnswers'
	},
	[DASHBOARD_RESOURCES.magicBox]: {
		createSchedule: 'createSchedule',
		removeSchedule: 'removeSchedule'
	},
	[DASHBOARD_RESOURCES.delink]: {
		userPhone: 'userPhone'
	},
	[DASHBOARD_RESOURCES.outbound]: {
		addCampaignData: 'addCampaignData'
	},
	[DASHBOARD_RESOURCES.athenaDashboard]: {
		listAthenaQueries: 'listAthenaQueries',
		createAthenaQuery: 'createAthenaQuery',
		updateAthenaQuery: 'updateAthenaQuery',
		approveAthenaCrudRequest: 'approveAthenaCrudRequest',
		rejectAthenaCrudRequest: 'rejectAthenaCrudRequest',
		listAthenaCrudRequest: 'listAthenaCrudRequest',
		updateAthenaCrudRequest: 'updateAthenaCrudRequest',
		getAthenaCrudRequestVersionHistory: 'getAthenaCrudRequestVersionHistory'
	},
	[DASHBOARD_RESOURCES.themesZipValidation]: {
		addData: 'addData'
	},
	[DASHBOARD_RESOURCES.internalUser]: {
		getInternalUserList: 'getInternalUserList',
		addInternalUser: 'addInternalUser',
		updateInternalUser: 'updateInternalUser'
	},
	[DASHBOARD_RESOURCES.configImpact]: {
		listKeys: 'listKeys',
		viewDetail: 'viewDetail',
		analyzeImpact: 'analyzeImpact',
		viewHistory: 'viewHistory',
		triggerRebuild: 'triggerRebuild'
	},
	[DASHBOARD_RESOURCES.mandateRefund]: {
		// Read only: works out which uids can be refunded.
		resolve: 'resolve',
		// Moves money. Grant separately from resolve.
		execute: 'execute'
	}
};

export const SETTINGS_SCOPES: Scopes = {
	[SETTINGS_RESOURCES.user]: {
		login: 'login',
		createUser: 'createUser',
		editUser: 'editUser',
		listUsers: 'listUsers'
	},
	[SETTINGS_RESOURCES.role]: {
		getRoles: 'getRoles',
		updateRole: 'updateRole',
		createRole: 'createRole'
	}
};

export const GAME_ADMIN_SCOPES: Scopes = {
	[GAME_ADMIN_RESOURCES.zookeeper]: {
		listServices: 'listServices',
		listKeys: 'listKeys',
		getValueForKey: 'getValueForKey',
		updateKey: 'updateKey',
		updateZKUpdateReq: 'updateZKUpdateReq',
		getAllPendingZkUpdateReqs: 'getAllPendingZkUpdateReqs'
	},
	[GAME_ADMIN_RESOURCES.zkPreProd]: {
		listServices: 'listServices',
		listKeys: 'listKeys',
		getValueForKey: 'getValueForKey',
		updateKey: 'updateKey',
		updateZKUpdateReq: 'updateZKUpdateReq',
		getAllPendingZkUpdateReqs: 'getAllPendingZkUpdateReqs'
	},
	[GAME_ADMIN_RESOURCES.zkRevertDashboard]: {
		getZkChangeHistory: 'getZkChangeHistory',
		revertZkConfigChange: 'revertZkConfig'
	},
	[GAME_ADMIN_RESOURCES.zkDashBoardUpdate]: {
		getDefaultValueForKey: 'getDefaultValueForKey',
		updateZkKeyPartially: 'updateZkKeyPartially',
		promoteToProdDirectly: 'promoteToProdDirectly'
	}
};

export const SCOPES_MAP: { [key: string]: Scopes } = {
	[PAGE_NAMES.dashboard]: DASHBOARD_SCOPES,
	[PAGE_NAMES.gameAdmin]: GAME_ADMIN_SCOPES,
	[PAGE_NAMES.settings]: SETTINGS_SCOPES
};
export const RESOURCES_MAP: { [key: string]: Resources } = {
	[PAGE_NAMES.dashboard]: DASHBOARD_RESOURCES,
	[PAGE_NAMES.gameAdmin]: GAME_ADMIN_RESOURCES,
	[PAGE_NAMES.settings]: SETTINGS_RESOURCES
};

export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const successType = 'success';
export const errorType = 'error';
export const revertSuccessMessage = 'Config Reverted.';
export const REVERT_ZK_CONFIG_ERROR_MESSAGE = 'Some error ocurred while Reverting config';
export const revertWarningMessage = `This is a new key. The key will be deleted after revert. Please restart the service after reverting.`;
export const CONFIG_DIFFERENCE = 'Config Difference';
export const maxNum = 100;
export const WebsiteUpdateDashboardBucketsList = {
	CONTROL: 'control',
	TEST_1: 'test_1',
	TEST_2: 'test_2'
};
export const SEGMENT_NAME_VALIDATON_MESSAGE = `Segment Name must start with an alphabetic letter,  and should contain only alphabetic letters or numbers or  '_'`;
export const ABTEST_NAME_VALIDATON_MESSAGE = `AB test name must be valid and active. Use commas to separate multiple AB test names.`;
export const ABTEST_NAME_PLACEHOLDER_MESSAGE = `Eg. D1Retention,pawV3Contest`;
export const SEGMENT_ABTEST_NAME_VALIDATON_MESSAGE = `You can also enter a combination of Segment Name, A/B Test Name, and Bucket Name, separated by hashes ($). Required format: SegmentName$ABTestName$BucketName.`;
export const SEGMENT_ABTEST_NAME_PLACEHOLDER_MESSAGE = `Eg. ps_abtest_v2$revengeExperiment$control`;
export const ZUPEE_USER_ID_DESCRIPTION_MESSAGE = `Please check the zupee user IDs. Each ID must be 15 digits long and separated by commas`;
export const ZUPEE_USER_ID_VALIDATION_MESSAGE = `Invalid format : Ensure all User IDs are exactly 15 digits long and separated by commas`;
export const ESegmentStatus = {
	DRAFT: 'Draft',
	ACTIVE: 'Active',
	INACTIVE: 'Inactive'
};
export const NA_VALUE: string = 'N/A';
export const MILLISECONDS_IN_29_DAYS: number = 29 * 24 * 60 * 60 * 1000;
export const JOB_NAME: string = 'user-segment-calculation';
export const GAME_NAME: string = 'LUDO';
export const IS_RAPID: string = 'isRapid';
export enum ESegmentType {
	SEGMENT = 'SEGMENT',
	MULTI_SEGMENT = 'MULTI_SEGMENT',
	COMMON_SEGMENT = 'COMMON_SEGMENT',
	LIVE_SEGMENT = 'LIVE_SEGMENT',
	DERIVED_SEGMENT = 'DERIVED_SEGMENT'
}
export enum EFrequencyType {
	ONCE = 'ONCE',
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY'
}
export enum ERapidStatus {
	EXECUTABLE = 'Executable',
	EXPIRED = 'Expired'
}
export enum ESegmentState {
	DRAFT = 'Draft',
	ACTIVE = 'Active',
	INACTIVE = 'Inactive'
}
export const JOBS_ENDPOINTS = {
	EXECUTE_SEGMENT: '/marketing/dashboard/userSegment/execute',
	DELETE_SCHEDULED_CRON_JOB: '/marketing/dashboard/userSegment/deleteScheduledCronJob',
	SCHEDULE_SEGMENT: '/marketing/dashboard/userSegment/schedule'
};

export enum ESegmentEvaluationStatus {
	STARTED = 'STARTED',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED'
}

export const DOWNTIME_REFUND_MINIMUM_TIME_DIFF_IN_MINUTES = 15;
